import { Component } from 'react';

export class FailedSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;
        return (
            <svg
                className={className}
                data-testid="failed-circle-svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z"
                    fill="#DE1E1E"
                />
                <path
                    d="M10.2769 10.5893V12.4643C10.2769 12.6094 10.2239 12.7349 10.1179 12.841C10.0118 12.947 9.88629 13 9.7412 13H7.59834C7.45325 13 7.32769 12.947 7.22167 12.841C7.11564 12.7349 7.06263 12.6094 7.06263 12.4643V10.5893C7.06263 10.4442 7.11564 10.3186 7.22167 10.2126C7.32769 10.1066 7.45325 10.0536 7.59834 10.0536H9.7412C9.88629 10.0536 10.0118 10.1066 10.1179 10.2126C10.2239 10.3186 10.2769 10.4442 10.2769 10.5893ZM10.528 1.75L10.2937 8.17857C10.2881 8.32366 10.2295 8.44922 10.1179 8.55525C10.0118 8.66127 9.88629 8.71429 9.7412 8.71429H7.59834C7.45325 8.71429 7.3249 8.66127 7.2133 8.55525C7.10727 8.44922 7.05147 8.32366 7.04589 8.17857L6.81151 1.75C6.80593 1.60491 6.85336 1.47935 6.95381 1.37333C7.05984 1.2673 7.18539 1.21429 7.33048 1.21429H10.0091C10.1541 1.21429 10.2769 1.2673 10.3774 1.37333C10.4834 1.47935 10.5336 1.60491 10.528 1.75Z"
                    transform="translate(4 5.5)"
                    fill="white"
                />
            </svg>
        );
    }
}
